import React, { useEffect, useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { FaWhatsapp } from 'react-icons/fa6';
import QRCode from 'qrcode';

import { API_BASE_URL } from '../../../../config/config.js'; 
import './confirmacion.css';

export const Confirmacion = ({ id, phoneNumber, eventos, capacityInitial, capacityMax, nombrePaquetes }) => {
  const [name, setName] = useState('');
  const [userPhone, setUserPhone] = useState('');
  const [eventType, setEventType] = useState('');
  const [packageType, setPackageType] = useState('');
  const [namePackage,setnamePackage]=useState('');
  const [eventDate, setEventDate] = useState('');
  const [visitType, setVisitType] = useState('Visita');
  const [peopleCount, setPeopleCount] = useState(capacityInitial);
  const [folio, setFolio] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [showQR, setShowQR] = useState(false);
  const [generateWhatsAppLink] = useState(false);
  const [errors, setErrors] = useState({ name: '', phone: '' });
  const [userLocation, setUserLocation] = useState({ lat: null, long: null });
  const [touchedName, setTouchedName] = useState(false); // Para saber si el campo "name" fue tocado
  const [touchedPhone, setTouchedPhone] = useState(false); // Para saber si el campo "phone" fue tocado

  const qrRef = useRef(null);
  const eventosConOtro = [...eventos, { name: 'Otro tipo' }];
  const paquetesOrdenados = [...nombrePaquetes].sort((a, b) =>  a.nombre.localeCompare(b.nombre)  );
  
  eventosConOtro.sort((a, b) => {
    if (a.name === "Otro tipo") return 1; // Mueve "Otro tipo" al final
    if (b.name === "Otro tipo") return -1; 
    return a.name.localeCompare(b.name); // Ordena alfabéticamente
  });

    //console.log("eventos ordenados",eventosConOtro);

  const getUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const latitude = position.coords.latitude;   // Obtenemos la latitud
        const longitude = position.coords.longitude; // Obtenemos la longitud
  
        // Guardamos cada uno por separado en localStorage
        localStorage.setItem('userLatitude', JSON.stringify(latitude));
        localStorage.setItem('userLongitude', JSON.stringify(longitude));
  
        // Establecemos el estado con los valores de latitud y longitud
        setUserLocation({ latitude, longitude });
  
        console.log('Latitud guardada en localStorage:', latitude);
        console.log('Longitud guardada en localStorage:', longitude);
      }, (error) => {
        console.error('Error al obtener la ubicación:', error);
      });
    } else {
      console.error('Geolocalización no soportada en este navegador.');
    }
  };

  // Función para cargar la ubicación desde localStorage
  const loadLocationFromLocalStorage = () => {
    const savedLocation = localStorage.getItem('userLocation');
    if (savedLocation) {
      const location = JSON.parse(savedLocation);
      setUserLocation(location);
      console.log('Ubicación leída desde el localStorage:', location);
    } else {
      getUserLocation(); // Si no existe, obtenemos la ubicación del usuario
    }
  };

  useEffect(() => {
    loadLocationFromLocalStorage();
  }, []);

  const { latitude, longitude } = userLocation;  // Desestructuración del objeto

  console.log("lat",latitude);  // Accede al valor de la latitud
  console.log(longitude); // Accede al valor de la longitud


  // Obtener la fecha de hoy
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);
  const oneYearLater = new Date();
  oneYearLater.setFullYear(today.getFullYear() + 1); // Suma un año completo
  
  const minDate = tomorrow.toISOString().split('T')[0];
  const maxDate = oneYearLater.toISOString().split('T')[0];

  const validateFields = () => {
    let valid = true;
    const newErrors = { name: '', phone: '' };

    if (!name || name.trim().length < 2) {
      newErrors.name = 'Debe tener al menos 3 caracteres.';
      valid = false;
    }

    if (userPhone.length !== 10) {
      newErrors.phone = 'El teléfono debe contener 10 dígitos.';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    setTouchedName(true); // Marcar que el campo "name" fue tocado
    validateFields();
  };

  const handlePhoneChange = (event) => {
    const value = event.target.value;
    setTouchedPhone(true); // Marcar que el campo "phone" fue tocado

    if (/^\d{0,10}$/.test(value)) {
      setUserPhone(value);
    }

    // Validación en tiempo real para el teléfono
    if (value.length !== 10) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phone: 'El teléfono debe contener 10 dígitos.',
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phone: '', // Si la longitud es correcta, eliminamos el error
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (userPhone.length !== 10 || errors.name || errors.phone) {
      return;
    }

    const generatedFolio = `Enfiestate-${uuidv4()}`;
    setFolio(generatedFolio);
    setShowQR(true);

    // const formData = JSON.parse(localStorage.getItem('formData'));

    const selectedEvent = eventos.find(event => event.name === eventType);
    const selectedPackage = nombrePaquetes.find(packag => packag.id === (packageType ? Number(packageType) : null));

    if (!selectedEvent || !selectedPackage) {
      console.error('Debe seleccionar un evento y un paquete válidos');
      return;
    }

    console.log("Prueba de coordenadas",{ userLocation })

    const dataToSend = {
      lugarId: id,
      nombreUsuario: name,
      telefonoUsuario: userPhone,
      emailUsuario: null,
      fechaPosibleReserva: eventDate,
      folioQr: generatedFolio,
      tiempoFormularioSegundos: null,
      tipoEventoId: selectedEvent.id,
      tipoEventoNombre: eventType,
      paqueteId: selectedPackage.id,
      paqueteNombre: selectedPackage.nombre,
      numeroPersonas: peopleCount,
      ubicacionUsuario:`(${latitude}, ${longitude})`
    };

    console.log("dataToSend:", JSON.stringify(dataToSend, null, 2));
    const url = `${API_BASE_URL}/reservaciones`;
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      });

      if (!response.ok) {
        throw new Error('Error al guardar la reservación');
      }

      console.log('Reserva enviada con éxito');
    } catch (error) {
      console.error('Error al enviar la reservación:', error);
    }
  };

  const handlePeopleCountChange = (event) => {
    const value = Number(event.target.value);
    let message = '';

    if (!isNaN(value)) {
      if (value < capacityInitial) {
        message = `El mínimo es ${capacityInitial} personas.`;
      } else if (value > capacityMax) {
        message = `El máximo es ${capacityMax} personas.`;
      } else {
        message = '';
      }
      setPeopleCount(value);
    } else {
      message = '';
    }

    setAlertMessage(message);
  };

  const handleDoubleClick = (event) => {
    event.target.select();
  };

  useEffect(() => {
    if (eventType !== '' || packageType !== '' || eventDate !== '' || peopleCount !== capacityInitial) {
      setShowQR(false);
    }
  }, [eventType, packageType, eventDate, peopleCount]);

  useEffect(() => {
    if (!checkFieldsBeforeShowQR()) {
      setShowQR(false);
    }

    if (showQR && qrRef.current) {
      const message = `Hola, me gustaría ${visitType} para un evento con los siguientes detalles:\nNombre: ${name}\nTeléfono: ${userPhone}\nFolio: ${folio}\nTipo de Evento: ${eventType}\nPaquete: ${namePackage}\nFecha del Evento: ${eventDate}\nNúmero de Personas:${peopleCount}`;
      const whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

      if (!generateWhatsAppLink) {
        QRCode.toCanvas(qrRef.current, whatsappURL, (error) => {
          if (error) console.error(error);
        });

        const selectedEvent = eventos.find(event => event.name === eventType);
        const selectedPackage = nombrePaquetes.find(packag => packag.id === (packageType ? Number(packageType) : null));

        console.log('Paquete seleccionado:', selectedPackage);

        const formData = {
          id,
          name,
          userPhone,
          folio,
          eventTypeId: selectedEvent ? selectedEvent.id : null,
          eventType,
          idPackage: selectedPackage ? selectedPackage.id : null,
          packageType,
          numPeople: peopleCount,
          eventDate,
          ubicacionUsuario:`(${latitude}, ${longitude})`
        };


        console.log('pppPaquetes:', nombrePaquetes);
        setVisitType(visitType)
        const selectedPackageNombre = selectedPackage.nombre;
        setnamePackage(selectedPackageNombre);
        console.log('Tipo de paquete seleccionado:', packageType, selectedPackageNombre, visitType);
        

        localStorage.setItem('formData', JSON.stringify(formData));
      }

      if (generateWhatsAppLink) {
        document.getElementById('whatsapp-link').innerHTML = `<a href="${whatsappURL}" target="_blank" rel="noopener noreferrer">Enviar por WhatsApp</a>`;
      }
    }
  }, [showQR, folio, eventType, packageType, eventDate, userPhone, name, peopleCount, generateWhatsAppLink]);

  const checkFieldsBeforeShowQR = () => {
    return eventType && packageType && eventDate && peopleCount && userPhone.length === 10 && name.trim().length >= 3 && !errors.name && !errors.phone;
  };

  useEffect(() => {
    if (!checkFieldsBeforeShowQR()) {
      setShowQR(false);
    }
  }, [name, userPhone, eventType, packageType, eventDate, peopleCount]);

  return (
    <div className="form-container">
      <h1>Consulta la disponibilidad</h1>
      <form onSubmit={handleSubmit}>
        <div className="input-group">
          <div className="input-pair">
            <label>
              Nombre:
              <input
                type="text"
                value={name}
                onChange={handleNameChange}
                placeholder="Escribe tu nombre"
              />
              {touchedName && errors.name && <p className="alert-message">{errors.name}</p>}
            </label>

            <label>
              Teléfono:
              <input
                type="text"
                value={userPhone}
                onChange={handlePhoneChange}
                placeholder="Teléfono"
                maxLength={10}
              />
              {touchedPhone && errors.phone && <p className="alert-message">{errors.phone}</p>}
            </label>
          </div>
        </div>
        <div className="input-group">
          <div className="input-pair">
            <label>
              Tipo de Evento:
              <select value={eventType} onChange={(e) => setEventType(e.target.value)} required>
                <option value="">Seleccione un tipo</option>
                {eventosConOtro.map((item) => (
                  <option key={item.id} value={item.name}>{item.name}</option>
                ))}
              </select>
            </label>
            <label>
              Paquete:
              <select value={packageType} onChange={(e) => setPackageType(e.target.value)} required>
                <option value="">Seleccione un paquete</option>
                {paquetesOrdenados.map((option, index) => (
                  <option key={index} value={option.id}>{option.nombre}</option>
                ))}
              </select>
            </label>
          </div>
        </div>
        <div className="input-group">
          <div className="people-selector-event">
            <label htmlFor="people-count">Núm. de personas:</label>
            <input
              id="people-count"
              type="number"
              min={capacityInitial}
              max={capacityMax}
              value={peopleCount || ''}
              onChange={handlePeopleCountChange}
              onDoubleClick={handleDoubleClick}
              placeholder="Introduce número"
            />
            {alertMessage && <p className="alert-message">{alertMessage}</p>}
          </div>
          <div className="input-pair">
            <label>
              Fecha del Evento:
              <input
                type="date"
                value={eventDate}
                onChange={(e) => setEventDate(e.target.value)}
                required
                min={minDate}
                max={maxDate}
              />
            </label>
          </div>
          <div className="input-pair">
            <label>
              Tipo:
              <select value={visitType} onChange={(e) => setVisitType(e.target.value)} required>
                <option value="Visita">Visita</option>
                <option value="Reservar">Reservar</option>
              </select>
            </label>
          </div>
        </div>

        {!checkFieldsBeforeShowQR() && (
          <p className="alertConfirmation">
            Todos los datos son necesarios para poder generar el QR.
          </p>
        )}

        <div className="button-container">
          <button type="submit" disabled={!checkFieldsBeforeShowQR()}>Generar</button>
        </div>
      </form>

      {showQR && !generateWhatsAppLink && (
        <React.Fragment>
          <div className="folio-canvas-container">
            <div>
              <canvas className="qr-container" ref={qrRef} />
            </div>  
            <div className="whatsapp-link" id="whatsapp-link">
              <a href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(`Hola, me gustaría ${visitType} para un evento con los siguientes detalles:\nNombre: ${name}\nTeléfono: ${userPhone}\nFolio: ${folio}\nTipo de Evento: ${eventType}\nPaquete: ${namePackage}\nFecha del Evento: ${eventDate}\nNúmero de Personas: ${peopleCount}`)}`} target="_blank" rel="noopener noreferrer">
                <div className="whatsapp-icon-text">
                  <FaWhatsapp className="icon-contacto" />
                  <span>Abrir desde WhatsApp</span>
                </div>
              </a>
            </div>
          </div>
          <h4 className='QR-text'>Escanea el QR o ingresa por WhatsApp</h4>
          <p className='QR-text'>Folio: {folio}</p>
        </React.Fragment>
      )}
    </div>
  );
};


